import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { listHotels } from "../api/hotels";
import { useAuth } from "../context/AuthContext";

export default function DemoAnalyticsNotice() {
  const { user, company_id: companyId } = useAuth();
  const isClient = Boolean(user && user.role !== "admin" && companyId);
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    if (!isClient || !companyId) {
      setShowNotice(false);
      return;
    }

    let isMounted = true;

    listHotels(companyId, { page: 1, per_page: 1 })
      .then((response) => {
        if (isMounted) setShowNotice(response.items.length === 0);
      })
      .catch(() => {
        if (isMounted) setShowNotice(false);
      });

    return () => {
      isMounted = false;
    };
  }, [companyId, isClient]);

  if (!showNotice) return null;

  return (
    <div className="border-b border-indigo-100 bg-indigo-50 text-indigo-900">
      <div className="mx-auto flex max-w-[1800px] flex-col items-center justify-center gap-3 px-7 py-3 text-center text-sm font-medium sm:flex-row">
        <div className="inline-flex items-center justify-center gap-3">
          <BarChart3 size={20} className="shrink-0 text-indigo-600" />
          <span>
            Доступны демо-данные аналитики. Чтобы ознакомиться со страницами аналитики, перейдите в демо-дашборд.
          </span>
        </div>
        <Link
          to="/analytics/dashboard"
          className="inline-flex shrink-0 items-center justify-center rounded-full bg-indigo-600 px-4 py-1.5 text-xs font-semibold text-white transition hover:bg-indigo-700"
        >
          Перейти в аналитику
        </Link>
      </div>
    </div>
  );
}
